import React from "react";
import Navbar from "../../Shared/Navbar/Navbar";
import Footer from "../../Shared/Footer/Footer";
import { ReactTyped } from "react-typed";
import AboutUs from "./aboutus";
import MoshjidCommittee from "./comittee";
import GoogleMapEmbed from "../Home/Location";

const About = () => {
  return (
    <>
      {/* Hero Section Container */}
      <div className="relative bg-aboutImg sm:bg-bannerImg-sm md:bg-bannerImg-md lg:bg-bannerImg-lg bg-cover bg-center w-full h-[65vh] flex flex-col justify-between">
        {/* Subtle top shading overlay ensuring text-white contrast for transparent Navbar link visibility */}
        <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-black/50 to-transparent pointer-events-none z-10" />

        <div className="relative w-full z-20">
          <Navbar />
        </div>

        {/* Typing Headliner Layer */}
        <div className="relative z-10 flex-1 flex flex-col items-center justify-center text-center px-4 max-w-4xl mx-auto">
          <span className="text-xs sm:text-sm font-bold tracking-widest uppercase text-emerald-800 bg-stone-100/90 px-4 py-1.5 rounded-full backdrop-blur-sm mb-3 shadow-sm">
            Learn Our History
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-slate-900 tracking-tight leading-tight mb-2">
            Mohammadia Baria Jam E Masjid
          </h1>
          <div className="h-10 text-xl sm:text-2xl font-bold text-emerald-800">
            <ReactTyped
              strings={[
                "Islamic Education & Events",
                "Community Support & Donations",
              ]}
              typeSpeed={80}
              backSpeed={60}
              loop
            />
          </div>
        </div>

        <div className="h-12 w-full bg-gradient-to-t from-stone-50 to-transparent" />
      </div>

      {/* Structured Content Segments */}
      <div className="bg-stone-50/50">
        <AboutUs />
        <MoshjidCommittee />

        <GoogleMapEmbed
          latitude={22.3816157}
          longitude={91.8167071}
          placeName="Our Location"
        />
      </div>

      <Footer />
    </>
  );
};

export default About;
